const Newsletter = {
  waitElement: function (selector) {
    return new Promise(function (resolve) {
      if (document.querySelector(selector)) {
        return resolve(document.querySelector(selector));
      }
      var observer = new MutationObserver(function(mutations) {
        if (document.querySelector(selector)) {
          resolve(document.querySelector(selector));
          observer.disconnect();
        }
      });
      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
    });
  },
  handleEstados: function () {
    var _this = this;

    var estados_input = $('[name="uf"]');
    var estados_select = $('.select#uf');
    var cidades_select = $('.select#city');
    var estados = estados_cidades.estados;
    var new_city = null;

    // SET FIRST VALUES
    estados_input.val(estados[0].sigla);
    // SET STATES SELECT
    estados_select.append('<option value="" selected disabled></option>')
    for (var i = 0; i < estados.length; i++) {
      estados_select.append(`<option value="${estados[i].sigla}">${estados[i].sigla}</option>`)
    }
    // HANDLE STATES SELECT
    $('.select#uf').on('change', function () {
      var estado = $(this).val();

      // SET NEW STATE
      estados_input.val(estado);

      // CLEAR CITIES SELECT
      cidades_select.empty();

      // SET CITIES SELECT
      for (var i = 0; i < estados.length; i++) {
        if (estados[i].sigla == estado) {
          for (var x = 0; x < estados[i].cidades.length; x++) {
            x == 0 ? new_city = estados[i].cidades[x] : null;
            cidades_select.append(`<option value="${estados[i].cidades[x]}">${estados[i].cidades[x]}</option>`)
          }
        }
      }

      // SET STORAGE
      localStorage.setItem('cart-state', estado);

      _this.handleCidades(new_city);
    });
    // SHOW FIRST CITIES
    for (var y = 0; y < estados[0].cidades.length; y++) {
      cidades_select.append(`<option value="${estados[0].cidades[y]}">${estados[0].cidades[y]}</option>`)
    }
  },
  handleCidades: function (new_city) {
    var cidades_input = $('[name="city"]');
    var estados = estados_cidades.estados;
    var cidades_select = $('.select#city');


    // SET FIRST VALUE
    // if (new_city) {
    //   cidades_input.val(new_city);
    // } else {
    //   cidades_input.val(estados[0].cidades[0]);
    // }

    cidades_select.prepend('<option value="" disabled selected></option>')

    // HANDLE CITIES SELECT
    $('.select#city').on('change', function () {
      var cidade = $(this).val();

      // SET NEW CITY
      cidades_input.val(cidade);

      // SET STORAGE
      localStorage.setItem('cart-city', cidade);
    });
  },
  handleBirthDate: function () {
    $('input.-birth').on('input', function (e) {
      $maxlength = $(this).attr('maxlength');

      if (e.target.value.length >= $maxlength) {
        $(this).next().next('input.-birth').focus();
      }

      $day = $('input.-birth.-day').val();
      $month = $('input.-birth.-month').val();
      $year = $('input.-birth.-year').val();

      if ($day && $month && $year) {
        $birth = $day + '/' + $month + '/' + $year;

        $('input[name="birth_date"]').val($birth);
      }
    });
  },
  handleGender: function () {
    const otherInput = document.querySelector('[data-gender-other]');
    const otherText = document.querySelector('[data-gender-text]')

    otherText.addEventListener('keyup', () => {
      otherInput.value = otherText.value;
      console.log(otherInput.value);
      console.log(otherText.value);
    })
  },
  handleInterests: function () {
    let chosenChoicesPage = document.querySelector('.newsletter-page-form .chosen-choices');
    let chosenChoicesPopup = document.querySelector('.newsletter-page-form .chosen-choices');
    const _this = this;
    let otherValuePage = document.querySelector('.newsletter-page-form [data-others]')
    let otherSelectPage = document.querySelector('.newsletter-page-form [data-other-select]')

    if (otherValuePage) otherValuePage.addEventListener('keyup', () => {
      otherSelectPage.value = otherValuePage.value;
    })

    let otherValuePopup = document.querySelector('.newsletter-bar [data-others]')
    let otherSelectPopup = document.querySelector('.newsletter-bar [data-other-select]')

    if (otherValuePopup) otherValuePopup.addEventListener('keyup', () => {
      otherSelectPopup.value = otherValuePopup.value;
    })
    
    this.waitElement('.newsletter-page-form .chosen-choices').then((chosenChoices) => {
      let observer = new MutationObserver(mutation => { 
        console.log('mutation run');
        let chosenOptions = chosenChoices.querySelectorAll('li span');
        let othersField = document.querySelector('.newsletter-page-form .others-field')
        let othersInput = document.querySelector('.newsletter-page-form [data-others]') 
        console.log(chosenOptions);
        let noOthers = true;
        chosenOptions.forEach((el) => { 
          if (el.innerHTML == 'Outros' || el.innerHTML == 'Others') {
            noOthers = false;
          } 
          console.log(el)
        }) 

        if (noOthers) {
          othersField.style.display = 'none';
          othersInput.disabled = true;
        } else {
          othersField.style.display = 'block';
          othersInput.disabled = false;
        }
      });
      observer.observe(chosenChoices, { attributes: true, childList: true, subtree: true });
    })

    this.waitElement('.newsletter-bar .chosen-choices').then((chosenChoices) => {
      let observer = new MutationObserver(mutation => { 
        console.log('mutation run');
        let chosenOptions = chosenChoices.querySelectorAll('li span');
        let othersField = document.querySelector('.newsletter-bar .others-field')
        let othersInput = document.querySelector('.newsletter-bar [data-others]') 
        let noOthers = true;
        chosenOptions.forEach((el) => { 
          if (el.innerHTML == 'Outros' || el.innerHTML == 'Others') {
            noOthers = false;
          } 
          console.log(el)
        }) 

        if (noOthers) {
          othersField.style.display = 'none';
          othersInput.disabled = true;
        } else {
          othersField.style.display = 'block';
          othersInput.disabled = false;
        }
      });
      observer.observe(chosenChoices, { attributes: true, childList: true, subtree: true });
      console.log("waitElement")
    })
    
  },
  handleNewsletter: function () {
    let $newsletter = $('.newsletter-bar');
    // handle local storage
    if (!localStorage.getItem('newsletter-closed')) {
      $(document).on("click", '.MuiButton-root', function(){
        setTimeout(function(){
          $('.newsletter-bar').addClass('active');
        }, 3000);
      })
    }
    // handle close
    $('[data-newsletter-close]').on('click', () => {
      localStorage.setItem('newsletter-closed', true);
      $('.newsletter-bar').removeClass('active');
    });
    // handle open
    $('[data-newsletter-open]').on('click', () => {
      $('.newsletter-bar').addClass('active');
      $('.newsletter-bar').find('input[type="email"]').focus();
    });
  },
  handleNewsletterPopup: function () {
    let $newsletter = $('.newsletter-popup');

  /*   $(".select_interest").chosen({allow_single_deselect:true}, {disable_search_threshold:10}, {no_results_text:'Não foi encontrado nada'}, {width:"100%"}); */
    // handle local storage
    if (!localStorage.getItem('newsletter-popup-closed')) {
      $newsletter.addClass('active');
      setTimeout(() => { $newsletter.find('input[type="email"]').focus() }, 666);
    }
    // handle close
    $('[data-newsletter-popup-close]').on('click', () => {
      localStorage.setItem('newsletter-popup-closed', true);
      $newsletter.removeClass('active');
    });
    // handle open
    $('[data-newsletter-popup-open]').on('click', () => {
      $newsletter.addClass('active');
      $newsletter.find('input[type="email"]').focus();
    });
  },
  init: function(){
    const _this = this;
    if (window.language != 'en') {
      _this.handleNewsletter();
      _this.handleNewsletterPopup();
    }

    _this.handleInterests();
    _this.handleEstados();
    _this.handleCidades();
    _this.handleGender();
    _this.handleBirthDate();
  }
}

export default Newsletter
